export const products = [
    {
        rootDevice: "caas",
        deviceName: "Intel x86",
    },
    {
        rootDevice: "cm4io",
        deviceName: "Raspberry Pi Compute Module 4",
    },
    {
        rootDevice: "cm5io",
        deviceName: "Raspberry Pi Compute Module 5",
    },
    {
        rootDevice: "imx8mm",
        deviceName: "NXP i.MX8 MM",
    },
    {
        rootDevice: "imx8mn",
        deviceName: "NXP i.MX8 MN",
    },
    {
        rootDevice: "imx8mp",
        deviceName: "NXP i.MX8 MP",
    },
    {
        rootDevice: "imx8mq",
        deviceName: "NXP i.MX8 MQ",
    },
    {
        rootDevice: "rpi4",
        deviceName: "Raspberry Pi 4B",
    },
    {
        rootDevice: "rpi5",
        deviceName: "Raspberry Pi 5",
    },
    {
        rootDevice: "rockpi4b",
        deviceName: "Rock 4B",
    },
    {
        rootDevice: "rockpi5b",
        deviceName: "Rock 5",
    },
] as const;

export const resolveHardwareName = (codename: string): string => {
    const match = products.find((product) => product.rootDevice === codename);
    return match?.deviceName ?? (codename.trim() || "-");
};

// Newest first: the product form defaults to the first entry, so a new product targets the latest release
export const androidVersionOptions: Record<string, string[]> = {
    caas: ["17", "16", "15", "14", "13"],
    cm4io: ["17", "16", "15", "14", "13", "11"],
    cm5io: ["17", "16", "15", "14"],
    rpi4: ["17", "16", "15", "14", "13", "11"],
    rpi5: ["17", "16", "15", "14"],
    rockpi4b: ["11"],
    rockpi5b: ["12"],
    imx8mp: ["14", "13", "12", "11"],
    imx8mm: ["14", "13", "12", "11"],
    imx8mn: ["14", "13", "12", "11"],
    imx8mq: ["14", "13", "12", "11"],
};

// A custom platform has no curated version list, so it must always offer every release emteria can build
export const allAndroidVersions = ["17", "16", "15", "14", "13", "12", "11"];
